export const hasPlate = (plates: any[], plate: any) => {
  return plates.filter(_row => {
    let row=_row.plate
    return row.left==plate.left && row.right==plate.right && row.middle==plate.middle && row.char==plate.char
  }).length > 0
}